import { render, staticRenderFns } from "./void-modal.vue?vue&type=template&id=d6432144"
import script from "./void-modal.vue?vue&type=script&lang=ts"
export * from "./void-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports